module.exports = __webpack_public_path__ + "img/r2_921_rebuild.d2aa514c.jpg";